import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Advice from "@/components/management/advice/Advice.vue";
import Leave from "@/components/management/advice/Leave.vue";
import { getAdvicePage, getAdviceInfo, handleAdviceDelete, getServeLeaveMessagePage, serveLeaveMessageAddAndEdit, getServeLeaveMessageInfo } from "@/api/managementCenter/advices";
import TreeSelect from "@/components/TreeSelect.vue";
import { getAdviceTypeList } from "@/api/personalCenter/suggestAngMsg";
import { getDeptTree } from "@/api/managementCenter/otherApi";
import byPageSelect from "@/components/byPageSelect.vue";
import { getSubjectList as _getSubjectList } from "@/api/managementCenter/themeManage";
export default {
  name: "Advices",
  components: {
    TreeSelect: TreeSelect,
    Advice: Advice,
    Leave: Leave,
    byPageSelect: byPageSelect
  },
  props: [],
  data: function data() {
    return {
      activeName: "advices",
      loading: false,
      statusList: [{
        value: "",
        name: "全部"
      }, {
        value: 0,
        name: "未处理"
      }, {
        value: 1,
        name: "已处理"
      }],
      typeList: [],
      departmentData: [],
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      list: [],
      leaveList: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        status: "",
        type: "",
        deptId: ""
      },
      leaveParamSearch: {
        current: 1,
        size: 10,
        status: "",
        subjects: [],
        deptId: ""
      },
      total: 0,
      leaveTotal: 0,
      subjectList: [],
      subjectParamSearch: {
        current: 1,
        size: 10,
        name: ""
      },
      subjectTotal: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
    this.getLeaveListFn();
    this.getAdviceTypeListFn();
    this.getSubjectList();
    this.getDeptTreeData();
  },
  methods: {
    getAdviceType: function getAdviceType(value) {
      if (value == 1) {
        this.paramSearch.deptId = "";
      }
    },
    setDeptSingleMenuAdvice: function setDeptSingleMenuAdvice(key, data) {
      this.paramSearch.deptId = data.id;
    },
    setDeptSingleMenuLeave: function setDeptSingleMenuLeave(key, data) {
      this.leaveParamSearch.deptId = data.id;
    },
    // 获取部门数据
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.departmentData = data.data;
        }
      }).catch(function (err) {});
    },
    // 获取建议类型
    getAdviceTypeListFn: function getAdviceTypeListFn() {
      var _this2 = this;

      getAdviceTypeList().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          var list = data.data || [];
          var arr = [];
          list.forEach(function (i) {
            for (var key in i) {
              arr.push({
                name: i[key],
                value: key
              });
            }
          });
          _this2.typeList = arr;
        }
      });
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this3 = this;

      this.loading = true;
      getAdvicePage(this.paramSearch).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.list = data.data.records || [];
          _this3.total = data.data.total;
        }
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 获取查询列表
    getLeaveListFn: function getLeaveListFn() {
      var _this4 = this;

      this.loading = true;
      getServeLeaveMessagePage(this.leaveParamSearch).then(function (_ref4) {
        var data = _ref4.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.leaveList = data.data.records || [];
          _this4.leaveTotal = data.data.total;
        }
      }).catch(function () {
        _this4.loading = false;
      });
    },
    getTypeText: function getTypeText(value) {
      var obj = {
        0: "网站建议",
        1: "部门建议",
        2: "纠错"
      };
      return obj[value + ""];
    },
    getAdviceDetail: function getAdviceDetail(id, type, status, attachUrl) {
      var _this5 = this;

      this.show = true;
      getAdviceInfo(id).then(function (_ref5) {
        var data = _ref5.data;
        _this5.show = false;

        if (data.code == 0) {
          _this5.$refs.Advice.dialogShow("detail", id, data.data || {}, _this5.getTypeText(type), status, attachUrl);
        }
      }).catch(function (err) {
        _this5.show = false;
      });
    },
    anSwerFn: function anSwerFn(id) {
      this.$refs.Advice.dialogShow("answer", id);
    },
    // 默认页面数据
    searchFn: function searchFn() {
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 默认页面数据
    searchLeaveFn: function searchLeaveFn() {
      this.leaveParamSearch.current = 1;
      this.getLeaveListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    },
    successBack: function successBack() {
      this.getLeaveListFn();
    },
    changeSizeLeave: function changeSizeLeave(value) {
      this.leaveParamSearch.size = value;
      this.leaveParamSearch.current = 1;
      this.getLeaveListFn();
    },
    // 翻页
    changePageLeave: function changePageLeave(value) {
      this.leaveParamSearch.current = value;
      this.getLeaveListFn();
    },
    getLeaveDetail: function getLeaveDetail(item) {
      this.$refs.Leave.dialogShow("detail", item);
    },
    LeaveanSwerFn: function LeaveanSwerFn(item) {
      this.$refs.Leave.dialogShow("answer", item);
    },
    getSubjectList: function getSubjectList() {
      var _this6 = this;

      // this.$refs.pageSelect.setToading(true)
      _getSubjectList(this.subjectParamSearch).then(function (_ref6) {
        var data = _ref6.data;

        // this.$refs.pageSelect.setToading(false)
        if (data.code == 0) {
          var list = data.data.records || [];
          _this6.subjectList = list.map(function (i) {
            return {
              value: i.id,
              name: i.name
            };
          });
          _this6.subjectTotal = data.data.total;
        }
      }).catch(function (err) {// this.$refs.pageSelect.setToading(false)
      });
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.subjectParamSearch.current = value;
      this.getSubjectList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.subjectParamSearch.size = value;
      this.subjectParamSearch.current = 1;
      this.getSubjectList();
    },
    subPage: function subPage() {
      this.subjectParamSearch = _objectSpread(_objectSpread({}, this.subjectParamSearch), {}, {
        current: 1
      });
      this.getSubjectList();
    },
    setValue: function setValue(data) {
      this.leaveParamSearch.subjects = data;
    }
  },
  watch: {},
  filters: {}
};